import type { CSSProperties } from 'react';

/** Shared modal close control — matches Auto Play popup (skyx_new). */
export const SKYX_MODAL_CLOSE = {
  iconColor: '#8B5CF6',
  hoverTextColor: '#ffffff',
  button: {
    background: 'rgba(31,10,77,0.4)',
    border: '1px solid rgba(143,77,255,0.35)',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#8B5CF6',
    fontSize: '16px',
    lineHeight: 1,
    padding: 0,
    cursor: 'pointer',
    boxShadow: 'none',
    outline: 'none',
  } satisfies CSSProperties,
  buttonHover: {
    background: 'rgba(179,71,255,0.2)',
    color: '#ffffff',
  } satisfies CSSProperties,
  buttonChipHover: {
    filter: 'brightness(1.15)',
  } satisfies CSSProperties,
  buttonMobile: {
    width: '30px',
    height: '30px',
  } satisfies CSSProperties,
  icon: {
    color: '#8B5CF6',
    fontSize: '22px',
    lineHeight: 1,
    fontWeight: 400,
    display: 'block',
    userSelect: 'none',
  } satisfies CSSProperties,
};
